const ParsedResult = ({ data, selectedRows, columnKeys, onPreview }) => {
  const parsed = [...selectedRows].map(i => {
    const row = data[i];
    return columnKeys.reduce((acc, key, idx) => {
      acc[key] = row[idx];
      return acc;
    }, {});
  });

  return (
    <div className="bg-gray-100 p-4 rounded">
      <h4 className="font-semibold mb-2">Dữ liệu đã chuyển đổi: {parsed.length} items</h4>
      <button
        className="mt-4 px-4 py-2 bg-green-600 text-white rounded"
        onClick={onPreview}
      >
        Preview
      </button>

      <div className="bg-white p-3 rounded overflow-y-auto max-h-[60vh]">
        <pre className="text-base whitespace-pre-wrap">
          {JSON.stringify(parsed, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default ParsedResult;
